import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { filter, Observable, Subject, Subscription, take, tap } from 'rxjs';
import { AuthService } from 'src/app/auth/services/auth.service';
import { BreadCrumbNavigation, MenuItem } from '../../models/MenuItem';
import { HomepageService } from 'src/app/modules/framework/home-pages/employee-home-page/services/homepage.service';
import { HomepageSetting } from 'src/app/modules/framework/home-pages/employee-home-page/models/HomepageSettings';
import { StudentRoleSettings, UserLevelEnum } from 'src/app/auth/models/UserData';
import { UserService } from 'src/app/auth/services/user.service';
import { Student } from 'src/app/modules/lms/learningpaths/models/interfaces';
import { EmployeeService } from 'src/app/shared/personnel-files/services/employee.service';
import { LabelService } from '../../../labels/services/label.service';
import { Label } from '../../../labels/models/Label';
import { NavigationService } from '../../services/navigation.service';
import { BreadcrumbService } from '../../services/breadcrumb.service';
import { Event, NavigationEnd, Router } from '@angular/router';
import { CompanyService } from 'src/app/shared/personnel-files/services/company.service';
import { Company } from 'src/app/shared/personnel-files/models/Company';
import { NgbModal, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { SideNavMenuItem } from '../sidenavbar/sidenavbar.component';
@Component({
  selector: 'app-top-navigation-mobile',
  templateUrl: './top-navigation-mobile.component.html',
  styleUrls: ['./top-navigation-mobile.component.scss']
})
export class TopNavigationMobileComponent implements OnInit {
  private _subscriptions: Subscription[] = [];
  private isLhr = false;

  public myProfileMenuItem$: Observable<MenuItem>;
  public whoKind: number = 3;
  public showFavourites = false;
  public roles$: Observable<StudentRoleSettings>;
  public Roles = UserLevelEnum;
  public breadCrumbStructure: BreadCrumbNavigation;
  public roleLabel = '';
  public eventsSubject: Subject<void> = new Subject<void>();
  public currentEmployee$: Observable<Student>;
  public toggleHamburgerMenu = false;
  public logoffLabel$: Observable<Label>;
  public birthdayToday: boolean;
  public greetingLabel = 'greeting_morning';
  public selectedTab: 'navigation' | 'role' = 'navigation';
  public navigationStructure$: Observable<MenuItem>;
  public navigationStructure: MenuItem;
  public activeMenuItem: MenuItem;
  public home: MenuItem;
  public activeTab = 1;

  public noActiveMenuItemFound: boolean;
  public menuStack: MenuItem[][] = [];
  public currentMenuItems: MenuItem[] = [];
  public companies: Company[] = [];
  @ViewChild('navCard') navCard!: ElementRef<HTMLDivElement>;
  @ViewChild('modalcontent') modalcontent: any;

  constructor(
    private _employeeService: EmployeeService,
    private companyService: CompanyService,
    private _navigationService: NavigationService,
    private _breadcrumbService: BreadcrumbService,
    private _labelService: LabelService,
    private _authService: AuthService,
    private _homepageService: HomepageService,
    private _userService: UserService,
    private _router: Router,
    private modalService: NgbModal,
  ) {
    const d = new Date();
    if (d.getHours() >= 5 && d.getHours() < 12) {
      this.greetingLabel = 'greeting_morning';
    } else if (d.getHours() >= 12 && d.getHours() < 14) {
      this.greetingLabel = 'greeting_noon';
    } else if (d.getHours() >= 14 && d.getHours() < 17) {
      this.greetingLabel = 'greeting_afternoon';
    } else if (d.getHours() >= 16) {
      this.greetingLabel = 'greeting_evening';
    }
  }

  public ngOnInit(): void {
    this.setupNavigationEventListener();
    this.activeTab = 1;
    this.currentEmployee$ = this._employeeService.getCurrentEmployee();
    this.navigationStructure$ = this._navigationService.fetchMenu();
    this.companyService.get().subscribe(e => {
      this.companies = e.filter(c => c.id > 1);
    })

    this._subscriptions.push(
      this._navigationService.fetchMenu().subscribe(homeData => {
        this.home = new MenuItem(homeData);
      })
    );
    this._subscriptions.push(
      this._breadcrumbService.url$.subscribe((url) => {
        if (url && url.length) {
          this.extractMenuItem(url);
        }
      })
    );

    this._subscriptions.push(
      this.navigationStructure$
        .pipe(take(1))
        .subscribe((menuItem: MenuItem) => {

          let itemToAdd: MenuItem;

          for (const subPage of menuItem.subPages) {
            for (const subSubPage of subPage.subPages) {
              if (subSubPage.id == 252) {
                itemToAdd = <any>{ ...subSubPage };
                subSubPage.hideInNavigation = true;
              }
            }
          }

          itemToAdd.label = menuItem.label;

          menuItem.subPages.splice(0, 0, itemToAdd);

          this.navigationStructure = menuItem;
          this.extractMenuItem(this._router.url);
        })
    );

    this.currentEmployee$ = this._employeeService.getCurrentEmployee().pipe(
      tap((e) => {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        e.birthday = new Date(e.birthday);
        if (e.birthday.getMonth() == d.getMonth() && e.birthday.getDate() == d.getDate()) {
          this.greetingLabel = 'greeting_birthday';
          this.birthdayToday = true;
        }
        this.eventsSubject.next();
      })
    );

    this._subscriptions.push(
      this._labelService.refreshPageNameInCache('general').subscribe((e) => {
        this.logoffLabel$ = this._labelService.getLabel(
          'logoff',
          'general',
          false
        );
      })
    );

    this._subscriptions.push(
      this._homepageService
        .getSettings(false)
        .subscribe((settings: HomepageSetting[]) => {
          if (localStorage.getItem('delegate_view') === '1') {
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 333).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 333 && e.name == 'show_favourites')[0]?.value;
          } else if (localStorage.getItem('manager_view') === '1') {
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 33).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 33 && e.name == 'show_favourites')[0]?.value;
          } else if (localStorage.getItem('trainer_view') === '1') {
            this.whoKind = 6;
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 6).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 6 && e.name == 'show_favourites')[0]?.value;
          } else if (localStorage.getItem('localhr_view') === '1') {
            this.whoKind = 2;
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 2).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 2 && e.name == 'show_favourites')[0]?.value;
            this.isLhr = true;
          } else if (localStorage.getItem('corporatehr_view') === '1') {
            this.whoKind = 1;
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 1).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 1 && e.name == 'show_favourites')[0]?.value;
          } else {
            settings = settings.filter(e => e.isVisible && e.value && e.roleId == 3).sort((a, b) => a.sortOrder - b.sortOrder);
            this.showFavourites = settings.filter(e => e.isVisible && e.roleId == 3 && e.name == 'show_favourites')[0]?.value;
          }
        }
        ));
    this.roles$ = this._userService.getUserRoles().pipe(
      tap((roles) => {
        if (roles && roles.level) {
          let role = this.Roles[roles.level];
          if (roles.isManager && localStorage.getItem('manager_view') === '1') {
            role = 'manager';
          }
          this.roleLabel = role;
          this.eventsSubject.next();
        }
      })
    );
  }

  public onNavChange(event: NgbNavChangeEvent) {
    this.activeTab = event.nextId;
  }

  public toggleSubmenu(item: MenuItem) {
    if (item.subPages && item.subPages.length) {
      this.menuStack.push(this.currentMenuItems);
      this.currentMenuItems = item.subPages;
      setTimeout(() => {
        this.navCard.nativeElement.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 0);
    }
  }

  public navigateToHomePage(menu?: SideNavMenuItem) {
    let menuItem;
    if (!menu) {
      menuItem = this.home;
    }
    if (menuItem && menuItem.getAngularUrl() && (menuItem.id != 697 && menuItem.id != 698 && menuItem.id != 699 && menuItem.id != 700)) {
      this.navigateToUrl(menuItem.getAngularUrl(), menuItem, null);
      return;
    }
  }

  // The pop function removes the previous element in the array of submenu items
  // so the user can go back in the menu structure
  public goBack() {
    if (this.menuStack.length) {
      this.currentMenuItems = this.menuStack.pop();
    }
    setTimeout(() => {
      this.navCard.nativeElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 0);
  }

  public navigate(event: any, menuItem: MenuItem, forceNewTab = false) {
    event = event || window.event;

    if (menuItem && menuItem.getAngularUrl() && (menuItem.id != 697 && menuItem.id != 698 && menuItem.id != 699 && menuItem.id != 700)) {
      this.navigateToUrl(menuItem.getAngularUrl(), menuItem, event, forceNewTab);
    }

    if (menuItem && (menuItem.id == 697 || menuItem.id == 698 || menuItem.id == 699 || menuItem.id == 700)) {
      let parameters = {};
      let url = 'chr/company';
      switch (menuItem.id) {
        case 697: url = 'chr/companydepartments';
          break;
        case 698:
        case 699: url = 'chr/companypositions';
          break;
        case 700: url = 'chr/companyfunctions';
          break;
      }
      if (this.companies.length == 1) {
        parameters['item'] = this.companies[0].id;
        this.navigateToUrl(url, menuItem, event, parameters);
      } else {
        let modal = this.modalService.open(this.modalcontent, { centered: false, backdrop: true, size: 'sm' });
        modal.result.then((a) => {
          parameters['item'] = a;
          this.navigateToUrl(url, menuItem, event, parameters);
        }, () => { })
      }
    }
    this.closeNavigationPopOver();
  }

  public showNavigationPopOver() {
    this.toggleHamburgerMenu = !this.toggleHamburgerMenu;
    document.body.classList.add('no-scroll');
  }

  public closeNavigationPopOver() {
    this.toggleHamburgerMenu = false;
    document.body.classList.remove('no-scroll');
  }

  public logOff(): void {
    this._authService.logOff();
  }

  public showTab(tab: 'navigation' | 'role', event: MouseEvent) {
    event.preventDefault();
    this.selectedTab = tab;
  }
  private navigateToUrl(url: string, menuItem: MenuItem, event, extraQueryParams?) {
    this._router.navigate([url], { queryParams: { menuItem: menuItem.id, ...extraQueryParams }, queryParamsHandling: 'merge' });
  }

  private formatUrl(url: string): string {
    let formattedUrl = url.replace('/', '');
    if (formattedUrl.indexOf('?') > -1) {
      formattedUrl = formattedUrl.slice(0, formattedUrl.indexOf('?'));
    }

    const parts = formattedUrl.split('/');
    if (new RegExp(/^\d+$/).test(parts[parts.length - 1])) {
      parts.pop();
      parts.push(':id');
      formattedUrl = parts.join('/');
    }

    return formattedUrl;
  }

  private extractMenuItem(url: string): void {
    let param = getParameterByName('menuItem', url);
    const formattedUrl = this.formatUrl(url);

    this._resetMenuItems([this.navigationStructure]);
    const activeMenuItem = this.containsUrl(
      formattedUrl,
      this.navigationStructure,
      param ? parseInt(param) : null
    );

    if (!activeMenuItem) {
      this.noActiveMenuItemFound = true;
      return;
    }

    this.noActiveMenuItemFound = false;
    this.activeMenuItem = activeMenuItem;
    this.breadCrumbStructure = { levels: [] };

    this.addBreadCrumbLevel([this.navigationStructure]);
    this.breadCrumbStructure.levels = this.breadCrumbStructure.levels.reverse();

    const allLevels = this.breadCrumbStructure.levels;
    const levels = allLevels.slice(1);

    this.menuStack = levels
      .map(l => l.menuItems)
      .slice(0, -1);

    const lastLevel = levels[levels.length - 1];
    this.currentMenuItems = lastLevel.menuItems;

    if (this.toggleHamburgerMenu) {
      setTimeout(() =>
        this.navCard.nativeElement.scrollTo({ top: 0, behavior: 'smooth' }),
        0);
    }
  }

  private addBreadCrumbLevel(menuItems: MenuItem[]): void {
    let allSubPages: MenuItem[] = [];
    let activeTrailMenuItem: MenuItem;
    let activeMenuItem: MenuItem;

    for (let i = 0; i < menuItems.length; i++) {
      const menuItem = menuItems[i];

      if (!menuItem) {
        continue;
      }

      if (menuItem.isActive) {
        activeMenuItem = menuItem;
        break;
      }

      if (menuItem.hasActiveTrail) {
        activeTrailMenuItem = menuItem;

        if (menuItem.subPages && menuItem.subPages.length) {
          allSubPages = allSubPages.concat(menuItem.subPages);
          break;
        }
      }
    }

    if (!activeMenuItem && allSubPages && allSubPages.length) {
      this.addBreadCrumbLevel(allSubPages);
    }

    if (activeMenuItem) {
      this.breadCrumbStructure.levels.push({
        menuItems: menuItems,
        activeMenuItem: activeMenuItem,
      });
    } else {
      this.breadCrumbStructure.levels.push({
        menuItems: menuItems,
        activeMenuItem: activeTrailMenuItem,
      });
    }
  }
  private containsUrl(formattedUrl: string, menuItem: MenuItem, menuItemId?: number, menuItemInParent = false): MenuItem {
    if (!menuItem) {
      return null;
    }

    const itemFormattedUrl = menuItem.url.substring(1);

    if (menuItem && (formattedUrl === itemFormattedUrl || formattedUrl.replace("/:id", "") === itemFormattedUrl) && (!menuItemId || menuItemId == menuItem.id || menuItemInParent)) {
      menuItem.isActive = true;
      return menuItem;
    }

    for (let i = 0; menuItem.subPages && i < menuItem.subPages.length; i++) {
      const subItem: MenuItem = menuItem.subPages[i];

      if (!subItem) {
        continue;
      }

      menuItemInParent = !!menuItemId && (menuItemInParent || menuItem.id == menuItemId);
      const activeMenuItem = this.containsUrl(formattedUrl, subItem, menuItemId, menuItemInParent);
      if (activeMenuItem != null) {
        menuItem.subPages[i].hasActiveTrail = true;
        menuItem.hasActiveTrail = true;
        return activeMenuItem;
      }
    }
    return null;
  }
  private setupNavigationEventListener(): void {
    this._subscriptions.push(
      this._router.events
        .pipe(
          filter((event: Event) => event instanceof NavigationEnd),
          tap((event: Event) => {
            this.extractMenuItem((event as NavigationEnd).url);
            this.eventsSubject.next();
          })
        )
        .subscribe()
    );
  }
  private _resetMenuItems(menuItems: MenuItem[]): void {
    for (let i = 0; i < menuItems.length; i++) {
      const menuItem = menuItems[i];

      if (!menuItem) {
        continue;
      }

      menuItem.isActive = false;
      menuItem.hasActiveTrail = false;
      menuItem.showChildren = false;
      if (menuItem.subPages) {
        this._resetMenuItems(menuItem.subPages);
      }
    }
  }

}
function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
